var map = {
	"./topic_beauty.png": 1023,
	"./topic_business.png": 1024,
	"./topic_comic-animation.png": 1025,
	"./topic_crypto.png": 1026,
	"./topic_education-parenting.png": 1027,
	"./topic_game.png": 1028,
	"./topic_gourmet.png": 1029,
	"./topic_others.png": 1030,
	"./topic_technology.png": 1031,
	"./topic_travel.png": 1032
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1022;